/**
 * 获取文件扩展名
 * @param filename 文件名
 * @param isIncludeDot 是否包含"."
 * @returns {string}
 */
export function getFileExtension(filename, isIncludeDot) {
  const extension = ''
  let pos = filename.lastIndexOf('.')
  if (pos === -1) {
    return extension
  }
  pos = isIncludeDot ? pos : pos + 1
  return filename.substring(pos)
}
// 获取 文件后缀名
export function getFileExtensionName(name) {
  return name.substring(name.lastIndexOf('.') + 1)
}
